export default __webpack_public_path__ + "static/yellow-331e2747da65021d35df178ca772aa2e.png";